import { QuotesCodeMapping } from '@/constants/quote/quote';

export interface Currency {
  [QuotesCodeMapping.SYMBOL]: string; // symbol
  [QuotesCodeMapping.UP_DOWN_DIRECTION]: number; // 漲跌方向
  [QuotesCodeMapping.CLOSE]: string; // 價格
  [QuotesCodeMapping.CHANGE_PERCENT_V2]: string; // 漲跌幅
}

export enum CurrencyKey {
  SYMBOL = QuotesCodeMapping.SYMBOL,
  DIRECTION = QuotesCodeMapping.UP_DOWN_DIRECTION,
  PRICE = QuotesCodeMapping.CLOSE,
  HEAT = QuotesCodeMapping.CHANGE_PERCENT_V2
}

export enum CrossRateTabs {
  PRICE = 0, // 價格
  HEAT = 1 // 熱圖(漲跌幅)
}

export enum Trend {
  UNCHANGED = 0, // 不變
  RISING = 1, // 上漲
  FALLING = 2 // 下跌
}

// 貨幣種類
export const CURRENCIES = ['TWD', 'USD', 'EUR', 'GBP', 'AUD', 'NZD', 'CAD', 'JPY', 'KRW', 'HKD', 'CNY'];
export const currenciesJoinString = CURRENCIES?.join(',');

// 交叉匯率貨幣對應的tab標籤
export const TABS_LABEL = [{ label: '價格' }, { label: '熱圖' }];
